import React, { useEffect, useState } from "react";
import dialog from "../../assets/images/pk-events/ic_in_room_pk_select_time_bg 1 (2).png";
import close from "../../assets/images/pk-events/close.png";
import { useTranslation } from "react-i18next";
import activeTabBar from "../../assets/images/pk-events/Rectangle.png";
import tabBar from "../../assets/images/pk-events/Rectangle (2).png";
import title from "../../assets/images/pk-events/title.png";
import backGround from "../../assets/images/pk-events/Rectangle 41.png";
import fallbackImage from "../../assets/icons/gift-box 1.png";

const RewardDialog = ({ isOpen, closeDialog, bonusData }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("tab1");
  const ImageBaseUrl = "https://media.tajichat.com/";

  const [imageErrors, setImageErrors] = useState({});
  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true, // Mark this item image as failed to load
    }));
  };
  const renderTabContent = () => {
    if (activeTab === "tab1") {
      return (
        <div className="tab-panel h-[100%] pb-[60px] relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className=" overflow-y-auto pr-2 mx-auto w-[90%] relative">
            <div className="relative top-[-25px] mx-auto w-[40%]"> </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 1")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_king?.top_1.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 2")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_king?.top_2.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 3")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_king?.top_3.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    } else if (activeTab === "tab2") {
      return (
        <div className="tab-panel h-[100%] pb-[60px] relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className=" overflow-y-auto pr-2 mx-auto w-[90%] relative">
            <div className="relative  top-[-25px] mx-auto w-[40%]"> </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 1")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_room?.top_1.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 2")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_room?.top_2.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 3")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_room?.top_3.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    } else if (activeTab === "tab3") {
      return (
        <div className="tab-panel h-[100%] pb-[60px] relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className=" overflow-y-auto pr-2 mx-auto w-[90%] relative">
            <div className="relative overflow-y-scroll top-[-25px] mx-auto w-[40%]">
              {" "}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 1")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_star?.top_1.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 2")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_star?.top_2.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
            <div className=" w-[60%] mx-auto my-3 relative mt-[15px] ">
              <img src={title} alt="rules" className={` h-[45px]`} />
              <p
                className={`absolute w-full top-1/2 font-rubik text-[#FFFFFF] font-semibold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] " text-[#FFFFFF]"  lg:text-xl md:text-base sm:text-sm xs:text-[1rem]   text-center`}
              >
                {t("Top 3")}
              </p>
            </div>{" "}
            <div className="flex  flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-start">
              {bonusData?.pk_star?.top_3.map((item) => (
                <div className="w-[32%] relative ">
                  <img
                    src={backGround}
                    alt="PK Reward Background"
                    className="inset-0 w-full object-cover rounded-2xl"
                  />
                  <img
                    src={
                      imageErrors[item?.image] // Check if this image has an error
                        ? fallbackImage
                        : `${ImageBaseUrl}${item?.image}`
                    }
                    onError={() => handleError(item?.image)} // Handle error for individual image
                    alt={item?.name}
                    className="w-[60px] h-[60px] absolute top-[10%] left-1/2 transform translate-y-[10%] -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
                  />{" "}
                  <p
                    className=" font-rubik font-medium text-center w-full  z-40 text-[#fff]  text-[10px] 
                 "
                  >
                    {item?.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
  };
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black   bg-opacity-50 flex items-end justify-center z-[999999]">
      <div
        style={{ width: "calc(100% - 20px)" }}
        className="w-[90%]  rounded-xl    relative dialog  shadow-lg"
      >
        <img
          src={dialog}
          alt="dialog"
          className="inset-0 w-full h-[65%] object-cover rounded-2xl"
        />
        <div className="absolute  top-[72px] h-[80%] inset-0 ">
          <div className="flex w-[90%]  relative  mx-auto gap-2 justify-center">
            {[
              {
                id: "tab1",
                label: "PK King",
                imgActive: activeTabBar,
                imgInactive: tabBar,
              },
              {
                id: "tab2",
                label: "PK Room",
                imgActive: activeTabBar,
                imgInactive: tabBar,
              },
              {
                id: "tab3",
                label: "PK Star",
                imgActive: activeTabBar,
                imgInactive: tabBar,
              },
            ].map((tab) => (
              <div
                key={tab.id}
                className={`  relative w-[32%] flex  flex-row cursor-pointer  `}
                onClick={() => setActiveTab(tab.id)}
              >
                <img
                  src={activeTab == tab.id ? tab.imgActive : tab.imgInactive}
                  alt="rules"
                  className={`w-[90%] h-[44px]`}
                />
                <p
                  className={`absolute w-full top-[60%] font-rubik font-extrabold left-[44%] transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%]${
                    activeTab == tab.id
                      ? " text-[#FFFFFF]"
                      : " text-[#FFFFFF80]"
                  } lg:text-xl md:text-base sm:text-sm xs:text-[1rem] font-normal  text-center`}
                >
                  {t(tab.label)}
                </p>
              </div>
            ))}
          </div>
          {renderTabContent()}
        </div>
        <p className="absolute top-[2px] font-lemon left-1/2 w-full p-4 z-40 transform -translate-x-1/2 text-[#fff]  xs:text-xl font-normal text-center">
          {t("Reward")}
        </p>
        <button
          onClick={closeDialog}
          className="absolute top-[1.2rem] z-50 right-[-2%]"
        >
          <img src={close} alt="close" className="w-8" />
        </button>
      </div>
    </div>
  );
};

export default RewardDialog;
